'use strict';

(() => {
    const $topZip = $('#topZip');

    let zipXhr = null,
        processedZip = null,
        processedCountry = null,
        zipPartner = null,
        keyDelay = null,
        currentPartner = window.partner;

    const getModalElements = (name) => {
        return {
            $modal: $(`#${name}Modal`),
            $zipInput: $(`#${name}ModalZip`),
            $countryInput: $(`#${name}ModalCountry`),
            $acceptButton: $(`#${name}ModalAcceptButton`)
        }
    }

    const handleZipInput = (name, event) => {
        const {$modal, $zipInput, $countryInput, $acceptButton} = getModalElements(name);
        if ($zipInput.val() !== processedZip || $countryInput.val() !== processedCountry) {
            abort();
            keyDelay = setTimeout(() => {
                validateZip(name);
            }, 500);
        }
    }

    const handleAcceptClick = (name) => {
        // Disclaimer Modal
        // -> Generic Carc with zip partner
        //   ↳ Redirect                             ✔︎
        // -> Generic Carc without zip partner
        //   ↳ Save and close                       ✔︎
        // -> standard partner with zip partner
        //   ↳ Ignore state partner, save and close ✔︎
        // -> standard partner without zip partner
        //   ↳ save and close                       ✔︎
        // -> state partner with different zip partner
        //   ↳ Redirect                             ✔︎
        // -> state partner with same zip partner
        //   ↳ Save and close                       ✔︎
        // -> state partner without zip partner
        //   ↳ Show retention modal                 ✔︎︎
        const {$modal, $zipInput, $countryInput, $acceptButton} = getModalElements(name);
        if ($modal.prop('id') === 'disclaimerModal' || $modal.prop('id') === 'zipModal') {
            if (currentPartner.subdomain === 'calculator') {
                if (zipPartner) {
                    redirectWithZip(name, zipPartner);
                } else {
                    saveZipStatus();
                    $modal.modal('hide');
                }
            } else {
                if (currentPartner.type === 'standard') {
                    saveZipStatus();
                    $modal.modal('hide');
                }

                if (currentPartner.type === 'state') {
                    if (zipPartner) {
                        if (zipPartner.state_code !== currentPartner.state_code) {
                            redirectWithZip(name, zipPartner);
                        } else {
                            saveZipStatus();
                            $modal.modal('hide');
                        }
                    } else {
                        // let $retentionModal = $('#retentionModal');

                        // hide the disclaimer modal
                        $modal.modal('hide');

                        // Copy the zip value to the retention modal
                        $('#retentionZipText').text(controller.current_values.zip);
                        $('#retentionPartnerText').text(currentPartner.name);
                        $('#retentionModalZip').val(controller.current_values.zip);
                        validateZip('retention');

                        // Show the Retention Modal
                        $('#retentionModal').modal('show');
                    }
                }
            }
        }

        // Retention Modal (being here assumes that partner.type=state and !zipPartner)
        // -> state partner with different zip partner
        //   ↳ Redirect                             ✔︎
        // -> state partner with same zip partner
        //   ↳ Save and close                       ✔︎
        // -> state partner without zip partner
        //   ↳ Redirect to generic                  ︎ ✔︎
        if ($modal.prop('id') === 'retentionModal') {
            if (zipPartner) {
                if (zipPartner.state_code !== currentPartner.state_code) {
                    redirectWithZip(name, zipPartner);
                } else {
                    saveZipStatus();
                    $modal.modal('hide');
                }
            } else {
                redirectWithZip(name);
            }
        }

    }

    const bindHandlers = (name) => {
        const {$modal, $zipInput, $countryInput, $acceptButton} = getModalElements(name);
        $zipInput.on('keyup change input', handleZipInput.bind(this, name));
        $countryInput.on('change', handleZipInput.bind(this, name));
        $acceptButton.on('click', handleAcceptClick.bind(this, name));
    }

    // Bind Zip and Country Input Events
    bindHandlers('disclaimer');
    bindHandlers('zip');
    bindHandlers('retention');

    // Open Change Zip Modal
    $topZip.click(async (event) => {
        const {$modal, $zipInput, $countryInput, $acceptButton} = getModalElements('zip');

        // Copy the zip value to the zip modal
        $zipInput.val($topZip.text());
        const zipLookup = await lookupZip($topZip.text());
        if (zipLookup && zipLookup.country) {
            $countryInput.val(zipLookup.country);
        }

        validateZip('zip');

        $modal.modal('show');
    });

    const abort = () => {
        // Clear the timeout and abort any active XHRs
        if (keyDelay) {
            clearTimeout(keyDelay);
        }
        if (zipXhr) {
            zipXhr.abort();
        }
    }

    const validateZip = (name) => {
        const {$modal, $zipInput, $countryInput, $acceptButton} = getModalElements(name);
        $modal.removeClass('success error loading');
        if (!$zipInput.val() || !$countryInput.val()) {
            $modal.removeClass('success error loading');
        } else {
            if (!$zipInput.val().match(/[0-9a-zA-Z\s]{5,7}/)) {
                $modal.addClass('error');
                $modal.find('.help-block.success').text('');
                controller.current_values.zip = undefined;
                return;
            }
            $modal.removeClass('success error').addClass('loading');
            zipXhr = $.get({
                data: {'country': $countryInput.val()},
                url: `/api/zipcodes/${$zipInput.val()}`,
                complete: r => {
                    if (r.status === 200) { // Zip Code Found
                        const zipResponse = r.responseJSON;
                        $modal.addClass('success');
                        // Some records have little or no info at all but still a valid zip code
                        const nameOrder = [
                            zipResponse.primary_city,
                            zipResponse.state,
                            zipResponse.county,
                            'Unknown',
                            zipResponse.country
                        ].filter((name) => !!name);
                        $modal.find('.help-block.success').text(`${nameOrder[0]}, ${nameOrder[1]}`);
                        controller.current_values.zip = zipResponse.zip;
                        controller.current_values.country = zipResponse.country;
                        zipPartner = zipResponse.partner;
                        if (zipPartner) {
                            zipPartner.zip = zipResponse.zip;
                            zipPartner.country = zipResponse.country;
                        }
                    } else { // Zip Code Not Found
                        $modal.addClass('error');
                        $modal.find('.help-block.success').text('');
                        controller.current_values.zip = undefined;
                        controller.current_values.country = undefined;
                    }
                    $modal.removeClass('loading');
                    processedZip = $zipInput.val();
                    processedCountry = $countryInput.val();
                }
            });
        }
    }

    const redirectWithZip = (name, zipPartner = {}) => {
        const {$modal, $zipInput, $countryInput, $acceptButton} = getModalElements(name);
        const {subdomain, zip, country} = zipPartner;
        let visitCount = 1;
        if (typeof (window.localStorage) !== 'undefined') {
            visitCount = parseInt(window.localStorage.getItem('visitCount'), 10) || 0;
        }
        const url = `${subdomain || 'calculator'}.${window.baseDomain}`;
        $acceptButton.find('.text').hide();
        $acceptButton.find('.loader').show();
        const $redirectForm = $('#partnerRedirectForm');
        $redirectForm.prop('action', '//' + url);
        $redirectForm.find('#redirectZip').removeProp('disabled').val(zip || $zipInput.val());
        $redirectForm.find('#redirectCountry').removeProp('disabled').val(country || $countryInput.val());
        $redirectForm.find('#redirectVisitCount').removeProp('disabled').val(visitCount);
        $redirectForm.find('#redirectUserHash').removeProp('disabled').val(window.userHash);
        $redirectForm.submit();
    };

    const saveZipStatus = () => {
        if (typeof (window.sessionStorage) !== 'undefined') {
            window.sessionStorage.setItem('terms_accepted', 'true');
            window.sessionStorage.setItem('zip', controller.current_values.zip);
            window.sessionStorage.setItem('country', controller.current_values.country);
            $('#registerForm #zipInput').val(controller.current_values.zip);
        }

        if ($topZip) {
            $topZip.text(controller.current_values.zip);
            $.post({
                url: `/api/user/update-zip/${controller.current_values.zip}`,
                complete: r => {
                    if (r.status === 200) { // Zip Code Found
                        $topZip.text(controller.current_values.zip);
                    }
                }
            });
        }
    }

    /*
     * We don't have the country so get it from the zip code
     * This could be potentially very slow so only do it if we absolutely have to.
     */
    const lookupZip = (zip) => {
        return new Promise((resolve, reject) => {
            $.get({
                url: `/api/zipcodes/lookup/${zip}`,
                complete: r => {
                    if (r.status === 200) { // Zip Code Found
                        const zipResponse = r.responseJSON;
                        resolve(zipResponse)
                    } else { // Zip Code Not Found
                        reject();
                    }
                }
            });
        });
    }
})();
